import React from 'react';
import { ReactComponent as UploadImg } from '../../../assets/new-icons/uploadImg.svg';
import { ReactComponent as RemoveImg } from '../../../assets/new-icons/close.svg';
import ConfermaBTN from '../../ConfermaBTN/ConfermaBTN'
import { useSelector } from 'react-redux';
import md5 from 'md5';
import { useFetchLoginGas } from '../../../functions/loginGas';

function EditInfo({ setEditInfo }) {
  const [state, setState] = React.useState({

    cell: null,
    email: null,
  })
  const customerId = useSelector((user) => user.gas.info.customer_id)
  const userId = useSelector((user) => user.gas.info.user_id)
  const tkn = md5(customerId + 'oYmAIdtki%lu')

  const apiUsr = `https://my.revoluce.it/area_utente/gestione/api/customers/setProfileGas.php?cell=${state.cell}&email=${state.email}&customer_id=${customerId}&user_id=${userId}&tkn_pvt=${tkn}`;
  const fetchLogin = useFetchLoginGas()

  


  const handleField = (e) => {
    setState(prevState => ({ ...prevState, [e.name]: e.value }))
  }
  const handleLocalStorage = () => {
    setEditInfo(false)
    if (state.username) {
      localStorage.setItem('username', state.username)
    } else if (state.password) {
      localStorage.setItem('password', state.password)
    }
    fetchLogin()
  }
  return (
    <>
      <div className="text">
        <p className="main">Modifica i tuoi dati</p>
        <p className="secondary">
          Modifica i dati relativi al tuo account e clicca su "Salva" per aggiornarli.
        </p>
      </div>
      <div className="editImage">

        <div className="upload__image-container">
          <div className="upload__image-wrapper">
            <img src="https://my.revoluce.it/area_utente/gestione/img/logo_circle.svg" alt="foto profilo" />
          </div>
        </div>
      </div>
      <div className="editFields">
        <div className="item">
          <p className="label">Email</p>
          <input name="email" type="email" placeholder='Email' onChange={(e) => handleField(e.target)}></input>
        </div>
        <div className="item">
          <p className="label">Telefono</p>
          <input name="cell" type='tel' placeholder='Telefono' onChange={(e) => handleField(e.target)}></input>
        </div>
      </div>

      <ConfermaBTN text="Conferma" confermTxt="Confermi di voler aggiornare i tuoi dati?" url={apiUsr} forward="/enrica/gas/profilo" customFunc={handleLocalStorage} />
    </>
  );
}

export default EditInfo;
